import { useLogin } from "@/api/console/login/useLogin";
import InputGroup from "@/components/InputGroup";
import Logo from "@/components/Logo/Logo";
import { Button } from "@/components/ui/button";
import { emailPattern } from "@/lib/regexPattern";
import toast from "@/lib/toast";
import { Login } from "@/schema/console/Login";
import { SpinnerIosRegular } from "@fluentui/react-icons";
import { setCookie } from "cookies-next";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

function LoginForm() {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Login>();

  const navigate = useNavigate();

  const { trigger, isMutating } = useLogin({
    onSuccess: (data) => {
      if (!data.data) return;
      const { token, user } = data.data;

      if (token) {
        setCookie("token", token, {
          maxAge: 60 * 60 * 24,
          path: "/",
        });
        setCookie("user", JSON.stringify(user), {
          maxAge: 60 * 60 * 24,
          path: "/",
        });

        navigate("/console/all-assessments");
      }
    },
    onError: (err) => {
      if (err.message && typeof err.message === "string") {
        toast.error(err.message);
      }
    },
  });

  const onSubmit = handleSubmit((data) => {
    trigger(data);
  });

  return (
    <div className="my-card w-[512px] p-6">
      <Logo href="/" />
      <div className="mt-4 text-xl font-bold text-cool-gray-800">
        {t("administrator-login")}
      </div>
      <div className="mt-2 font-medium text-cool-gray-800">
        {t("login-message")}
      </div>
      <form onSubmit={onSubmit} className="mt-8 flex flex-col gap-6">
        <InputGroup
          label={t("email")}
          type="email"
          error={errors.email?.message}
          register={register("email", {
            required: t("email-required"),
            pattern: {
              value: emailPattern,
              message: t("valid-email"),
            },
          })}
        />
        <InputGroup
          label={t("password")}
          error={errors.password?.message}
          register={register("password", {
            required: t("password-required"),
          })}
          type="password"
        />
        <Button
          LoadingComponent={<SpinnerIosRegular className="animate-spin" />}
          isLoading={isMutating}
          type="submit"
        >
          {t("login")}
        </Button>

        {/* <Link
          className="text-center font-medium text-cyan-600"
          to="/console/forget-password"
        >
          {t("forgot-password-message")}
        </Link> */}
      </form>
    </div>
  );
}

export default LoginForm;
